import * as React from "react";

export function Br(): JSX.Element {
    return <br />;
}
